import React, {useEffect} from "react";
import {useFormContext, useWatch} from "react-hook-form";
import InputForm from "./InputForm";
import {isBool, isEmpty} from "../../util/is";
import {ERRORFIELDREQUIRED} from "../../data/ConstantForm";


const NestedInputForm = ({disabled, keyFatherValue, keyIdentificador, label, readOnly,
                             required , className, placeHolder, type, executeFunction, customError }) => {

    const { control, setValue, formState: { errors } } = useFormContext();

    const nestedValue = useWatch({
        control,
        name: keyFatherValue
    });


    useEffect(() => {
        if(executeFunction){

            setValue(keyIdentificador, executeFunction(nestedValue));

        }
        else{

            setValue(keyIdentificador, nestedValue);

        }
    }, [nestedValue])

    return(
        <InputForm inputProps={{control}} disabled={disabled} identificador={keyIdentificador} label={label}
                   placeholder={placeHolder} type={type} readOnly={isBool(readOnly) ? readOnly : nestedValue === readOnly}
                   required={isBool(required) ? required : nestedValue === required} className={className}
                   customError={customError}  />
    )

}

export default NestedInputForm;
